/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.AuthKeyReq', null, global);
goog.exportSymbol('proto.BindReq', null, global);
goog.exportSymbol('proto.Msg', null, global);
goog.exportSymbol('proto.MsgEndPoint', null, global);
goog.exportSymbol('proto.MsgRsp', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AuthKeyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AuthKeyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.AuthKeyReq.displayName = 'proto.AuthKeyReq';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AuthKeyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.AuthKeyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AuthKeyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AuthKeyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    sysdimension: jspb.Message.getFieldWithDefault(msg, 1, ""),
    key: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AuthKeyReq}
 */
proto.AuthKeyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AuthKeyReq;
  return proto.AuthKeyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AuthKeyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AuthKeyReq}
 */
proto.AuthKeyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSysdimension(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AuthKeyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AuthKeyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AuthKeyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AuthKeyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSysdimension();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string sysDimension = 1;
 * @return {string}
 */
proto.AuthKeyReq.prototype.getSysdimension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.AuthKeyReq.prototype.setSysdimension = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string key = 2;
 * @return {string}
 */
proto.AuthKeyReq.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.AuthKeyReq.prototype.setKey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.BindReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.BindReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.BindReq.displayName = 'proto.BindReq';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.BindReq.prototype.toObject = function(opt_includeInstance) {
  return proto.BindReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BindReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BindReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    tobindbzid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    op: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bindendpoint: (f = msg.getBindendpoint()) && proto.MsgEndPoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BindReq}
 */
proto.BindReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.BindReq;
  return proto.BindReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BindReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BindReq}
 */
proto.BindReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTobindbzid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOp(value);
      break;
    case 3:
      var value = new proto.MsgEndPoint;
      reader.readMessage(value,proto.MsgEndPoint.deserializeBinaryFromReader);
      msg.setBindendpoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.BindReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.BindReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BindReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.BindReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTobindbzid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBindendpoint();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.MsgEndPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 toBindBzId = 1;
 * @return {number}
 */
proto.BindReq.prototype.getTobindbzid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.BindReq.prototype.setTobindbzid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string op = 2;
 * @return {string}
 */
proto.BindReq.prototype.getOp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.BindReq.prototype.setOp = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional MsgEndPoint bindEndPoint = 3;
 * @return {?proto.MsgEndPoint}
 */
proto.BindReq.prototype.getBindendpoint = function() {
  return /** @type{?proto.MsgEndPoint} */ (
    jspb.Message.getWrapperField(this, proto.MsgEndPoint, 3));
};


/** @param {?proto.MsgEndPoint|undefined} value */
proto.BindReq.prototype.setBindendpoint = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.BindReq.prototype.clearBindendpoint = function() {
  this.setBindendpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.BindReq.prototype.hasBindendpoint = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Msg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.Msg.displayName = 'proto.Msg';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Msg.prototype.toObject = function(opt_includeInstance) {
  return proto.Msg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Msg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Msg.toObject = function(includeInstance, msg) {
  var f, obj = {
    msgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bzid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    op: jspb.Message.getFieldWithDefault(msg, 3, ""),
    frommsgid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    from: (f = msg.getFrom()) && proto.MsgEndPoint.toObject(includeInstance, f),
    to: (f = msg.getTo()) && proto.MsgEndPoint.toObject(includeInstance, f),
    sdata: jspb.Message.getFieldWithDefault(msg, 7, ""),
    bzdata: jspb.Message.getFieldWithDefault(msg, 8, ""),
    rdata: jspb.Message.getFieldWithDefault(msg, 9, ""),
    tag: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Msg}
 */
proto.Msg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Msg;
  return proto.Msg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Msg}
 */
proto.Msg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBzid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrommsgid(value);
      break;
    case 5:
      var value = new proto.MsgEndPoint;
      reader.readMessage(value,proto.MsgEndPoint.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 6:
      var value = new proto.MsgEndPoint;
      reader.readMessage(value,proto.MsgEndPoint.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdata(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBzdata(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRdata(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Msg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Msg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBzid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFrommsgid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.MsgEndPoint.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.MsgEndPoint.serializeBinaryToWriter
    );
  }
  f = message.getSdata();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBzdata();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRdata();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string msgId = 1;
 * @return {string}
 */
proto.Msg.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.Msg.prototype.setMsgid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 bzId = 2;
 * @return {number}
 */
proto.Msg.prototype.getBzid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.Msg.prototype.setBzid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string op = 3;
 * @return {string}
 */
proto.Msg.prototype.getOp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.Msg.prototype.setOp = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string fromMsgId = 4;
 * @return {string}
 */
proto.Msg.prototype.getFrommsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.Msg.prototype.setFrommsgid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional MsgEndPoint from = 5;
 * @return {?proto.MsgEndPoint}
 */
proto.Msg.prototype.getFrom = function() {
  return /** @type{?proto.MsgEndPoint} */ (
    jspb.Message.getWrapperField(this, proto.MsgEndPoint, 5));
};


/** @param {?proto.MsgEndPoint|undefined} value */
proto.Msg.prototype.setFrom = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.Msg.prototype.clearFrom = function() {
  this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.Msg.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MsgEndPoint to = 6;
 * @return {?proto.MsgEndPoint}
 */
proto.Msg.prototype.getTo = function() {
  return /** @type{?proto.MsgEndPoint} */ (
    jspb.Message.getWrapperField(this, proto.MsgEndPoint, 6));
};


/** @param {?proto.MsgEndPoint|undefined} value */
proto.Msg.prototype.setTo = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.Msg.prototype.clearTo = function() {
  this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.Msg.prototype.hasTo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string sData = 7;
 * @return {string}
 */
proto.Msg.prototype.getSdata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.Msg.prototype.setSdata = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string bzData = 8;
 * @return {string}
 */
proto.Msg.prototype.getBzdata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.Msg.prototype.setBzdata = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string rData = 9;
 * @return {string}
 */
proto.Msg.prototype.getRdata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.Msg.prototype.setRdata = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string tag = 10;
 * @return {string}
 */
proto.Msg.prototype.getTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.Msg.prototype.setTag = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MsgEndPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MsgEndPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MsgEndPoint.displayName = 'proto.MsgEndPoint';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MsgEndPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.MsgEndPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MsgEndPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgEndPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    group: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MsgEndPoint}
 */
proto.MsgEndPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MsgEndPoint;
  return proto.MsgEndPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MsgEndPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MsgEndPoint}
 */
proto.MsgEndPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroup(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MsgEndPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MsgEndPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MsgEndPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgEndPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string group = 1;
 * @return {string}
 */
proto.MsgEndPoint.prototype.getGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.MsgEndPoint.prototype.setGroup = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sn = 2;
 * @return {string}
 */
proto.MsgEndPoint.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.MsgEndPoint.prototype.setSn = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 timestamp = 3;
 * @return {number}
 */
proto.MsgEndPoint.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.MsgEndPoint.prototype.setTimestamp = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.MsgRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.MsgRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.MsgRsp.displayName = 'proto.MsgRsp';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.MsgRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.MsgRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MsgRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    codemsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
    msgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    bzid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    op: jspb.Message.getFieldWithDefault(msg, 5, ""),
    frommsgid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MsgRsp}
 */
proto.MsgRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.MsgRsp;
  return proto.MsgRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MsgRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MsgRsp}
 */
proto.MsgRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCodemsg(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBzid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrommsgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.MsgRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.MsgRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MsgRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.MsgRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCodemsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBzid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOp();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFrommsgid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.MsgRsp.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.MsgRsp.prototype.setCode = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string codeMsg = 2;
 * @return {string}
 */
proto.MsgRsp.prototype.getCodemsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.MsgRsp.prototype.setCodemsg = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string msgId = 3;
 * @return {string}
 */
proto.MsgRsp.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.MsgRsp.prototype.setMsgid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 bzId = 4;
 * @return {number}
 */
proto.MsgRsp.prototype.getBzid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.MsgRsp.prototype.setBzid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string op = 5;
 * @return {string}
 */
proto.MsgRsp.prototype.getOp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.MsgRsp.prototype.setOp = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string fromMsgId = 6;
 * @return {string}
 */
proto.MsgRsp.prototype.getFrommsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.MsgRsp.prototype.setFrommsgid = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto);



// WEBPACK FOOTER //
// ./src/vendor/qnbar/msg_service_pb.js